// extracted by mini-css-extract-plugin
export var completionBody = "_ke-2";
export var completionCard = "_ke-0";
export var completionFooter = "_ke-3";
export var completionTitle = "_ke-1";